<template>
  <section class="grid-block">
    <header>
      Параметры сырья

      <VLink
        :disabled="product.hasCharacteristics() === false"
        @click="$core.utils.copyHtmlToClipboard(localProduct.copyProductCharacteristics())"
        material="copy"
      >
        Копировать характеристики
      </VLink>
    </header>

    <VFormItem class="product-category">
      <VSelectV2
        label="Категория"
        layout="vertical"
        hide-clear-btn
        :data="({pattern}) => ProductCategoriesService.getList({ pattern, isLeaf: true })"
        required

        :value="localProduct.category"
        @input="localProduct.setCategory($event)"
      >
        <template #option="{ option }">
          <div class="category-select-option">
            <VIcon
              :material="option.isBookmarked ? 'favorite' : 'favorite_border'"
            />
            {{ option.name }}
          </div>
        </template>
      </VSelectV2>

      <VLink
        :disabled="hasCategory === false"
        title="Добавить в избранное"
        @click="toggleCategoryBookmark"
        :material="getCategoryBookmarkIcon"
      />
    </VFormItem>

    <template v-if="hasCategory">
      <div
        v-for="(productCharacteristic, index) in localProduct.characteristics"
        :key="index"
      >
        <VInput
          v-if="productCharacteristic.isString || productCharacteristic.isLink"
          :label="productCharacteristic.name"
          clearable
          :required="productCharacteristic.validations?.isRequired"
          v-model="productCharacteristic.value"
        >
          <template #helper-text>
            <VLink
              class="ellipsis"
              style="width: 100%; text-align: left;"
              v-if="productCharacteristic.isLink"
              @click="onProductCharLinkClick(productCharacteristic.value)"
            >{{productCharacteristic.value}}</VLink>
          </template>
        </VInput>

        <VFormItem v-if="productCharacteristic.isNumeric"
                   :label="productCharacteristic.name"
                   ratio="1/1"
                   :with-asterisk="productCharacteristic.validations?.isRequired"
        >
          <VInputNumberRus
            :min="productCharacteristic.validations?.min"
            :max="productCharacteristic.validations?.max"
            :required="productCharacteristic.validations?.isRequired"
            :precision="productCharacteristic.validations?.precision || 3"
            clearable

            v-model="productCharacteristic.value.start"
          />

          <div class="delimiter"> – </div>

          <VInputNumberRus
            :min="productCharacteristic.validations?.min"
            :max="productCharacteristic.validations?.max"
            :required="productCharacteristic.validations?.isRequired"
            :precision="productCharacteristic.validations?.precision || 3"
            clearable

            v-model="productCharacteristic.value.end"
          />
        </VFormItem>

        <VSelectV2
          v-if="productCharacteristic.isSelectableSingle || productCharacteristic.isSelectableMulti"

          :label="productCharacteristic.name"
          clearable
          :required="productCharacteristic.validations?.isRequired"
          :data="productCharacteristic.allowedValues"
          multiple

          v-model="productCharacteristic.value"
        />

        <ProductCharacteristicsPictureInput
          v-if="productCharacteristic.isImage"

          :label="productCharacteristic.name"
          :entity-pointer="productEntityPointer"
          :required="productCharacteristic.validations?.isRequired"

            v-model="productCharacteristic.value"
        />

        <VSelectV2
          v-if="productCharacteristic.isEntityLink"

          multiple
          :required="productCharacteristic.validations?.isRequired"
          label="Ссылка на продукт"
          placeholder="Введите название продукта"
          :data="({pattern}) => ProductsService.search(pattern)"

          @input="onProductInput($event, productCharacteristic)"
          :value="productCharacteristic.value"
        >
          <template #selected-tag="{ option }" >
            <VLink
              @click="onProductLinkClick(option)"
              class="ellipsis"
            >{{option}}</VLink>

          </template>
        </VSelectV2>
      </div>
    </template>
  </section>
</template>

<script lang="ts">

import BookmarksService         from "@/domains/Bookmark/BookmarksService";
import ProductCategoriesService from '@/domains/ProductCategories/ProductCategoriesService';
import EntityPointer            from "@/domains/EntityPointer/EntityPointer";
import Product                  from "@/domains/Products/Product";
import ProductCharacteristic from "@/domains/Products/ProductCharacteristic";

import ProductCharacteristicsPictureInput
  from "@/domains/Products/components/ProductCharacteristicsPictureInput/ProductCharacteristicsPictureInput.vue";
import ProductsService from "@/domains/Products/ProductsService";
import {UnwrapNestedRefs} from "vue";

export default {
  name: 'ProductCharacteristics',
  components: { ProductCharacteristicsPictureInput },

  props: {
    product: {
      type: Object as PropType<Product | UnwrapNestedRefs<Product>>,
      default: null,
    },
  },

  setup() {
    return {
      ProductsService
    }
  },

  data() {
    const localProduct = this.product as Product;
    const productEntityPointer = new EntityPointer('product', localProduct.id, localProduct.toString())

    return {
      localProduct,
      productEntityPointer,
      ProductCategoriesService,

      unitList: [],
    };
  },

  computed: {
    hasCategory() {
      return Boolean(this.localProduct.category?.id);
    },

    getCategoryBookmarkIcon() {
      return this.localProduct.category?.getBookmarkIcon();
    },
  },

  methods: {
    onProductInput(products: Product[], productCharacteristic: ProductCharacteristic) {
      productCharacteristic.value = products.map(_product => new EntityPointer('product', _product.id, _product.name))
    },
    onProductCharLinkClick(link: string) {
      window.open(link, '_blank')
    },

    onProductLinkClick(entityPointer: EntityPointer) {
      this.$core.dialogs.ProductCard.showAsPromise({
        id: entityPointer.id
      })
    },

    async toggleCategoryBookmark() {
      if (this.localProduct.category === undefined || this.localProduct.category === null) return;

      const toggleAction = this.localProduct.category.isBookmarked ? 'delete' : 'add';

      await BookmarksService[toggleAction](this.localProduct.category.id)

      this.localProduct.category.isBookmarked = !this.localProduct.category.isBookmarked;
    },
  },
};
</script>
